import React from 'react';
import chunk from 'lodash/chunk';
import { CardRow } from '../card-row';
import { ProductHeader } from './product-header';

type ProductContainerProps = {
    className: string;
    cardBackground?: boolean;
    headline: string;
    items: [{}];
    itemsPerRow: number;
};

export const ProductContainer = ({
    className = '',
    cardBackground = false,
    headline = '',
    items = [],
    itemsPerRow = 1,
}: ProductContainerProps) => {

    if (!Array.isArray(items) || !items.length) {
        return null;
    }

    const rows = chunk(items, itemsPerRow);

    return (
        <div className={className}>
            <ProductHeader headline={headline} />
            <div className="products-body">
                {rows.map((row, rowIndex) => (
                    <React.Fragment key={rowIndex}>
                        <CardRow
                            items={row}
                            cardBackground={cardBackground}
                        />
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

